import styled from "styled-components";

export const Label = styled.label`
  display: block;
  font-weight: bold;
  font-size: 16px;
  margin-bottom: 10px;
`;

export const Checkbox = styled.div`
  cursor: pointer;
  display: flex;
  flex-direction: row;
`;

export const IconContainer = styled.div`
  display: flex;
  flex-shrink: 0;
  justify-content: center;
  align-items: center;
  width: 20px;
  height: 20px;
  border: 1px solid #888888;
  border-radius: 2px;
  margin-right: 12px;
`;

export const TextContainer = styled.div`
  font-weight: 600;
`;
